// @ts-nocheck
import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import "./App.scss";
import ThemeProvider from "./contexts/ThemeProvider";
import Main from "./containers/Main";
import FifaAnalysis from "./containers/fifaAnalysis/FifaAnalysis";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/fifa-analysis" element={<FifaAnalysis />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
